(function() {

	'use strict';

	angular.module('Services').service('ReportingServiceBySpendTableService', ReportingServiceBySpendTableService);

	function ReportingServiceBySpendTableService(Shipments, Carrier, TableLiteFactory, CommonService, trackingStatusesConst, toastr) {
		var ReportingServiceBySpendTable = {
            tableName: 'ReportingServiceBySpendTableService',
			config: {
				noPagination: false,
				noHeaders: false,
				noItemsView: false,
				noTableFooter: false,
			},
			headers: [{
				label: 'Service Name',
				viewName: 'serviceName',
				filterName: 'serviceName',
				filter: {
					type: 'text',
					class: 'bba-ref-no',
					placeholder: 'Search',
					onSubmit: function(header) {
                        sendRequest(evaluateFilter(header));
                    },
				},
				headerFn: function() {
                    sort(this.filterName);
                }
			}, {
				label: 'MONTH',
				viewName: 'amountMonth',
				filter: {
					type: 'inputDropdown',
					class: 'bba-ref-no',
					placeholder: 'Search',
					items: [{
						viewName: 'Month 1'
					}, {
						viewName: 'Month 2'
					}],
					onSubmit: function() {
						console.log(this);
					}
				},
				headerFn: function() {}
			}, {
				label: 'MONTH LAST YEAR',
				viewName: 'comparableMonthLastYear',
				filter: {
					type: 'text',
					class: 'bba-ref-no',
					placeholder: 'Search',
					onSubmit: function() {
						console.log(this);
					}
				},
				headerFn: function() {}
			}, {
				label: 'YEAR',
				viewName: 'amountYear',
				filter: {
					type: 'inputDropdown',
					class: 'bba-ref-no',
					placeholder: 'Search',
					items: [{
						viewName: 'Test'
					}, {
						viewName: 'Test2'
					}],
					onSubmit: function() {
						console.log(this);
					}
				},
				headerFn: function() {}
			}, {
				label: 'LAST YEAR',
				viewName: 'comparableYear',
				filter: {
					type: 'inputDropdown',
					class: 'bba-ref-no',
					placeholder: 'Search',
					items: [{
						viewName: 'Test'
					}, {
						viewName: 'Test2'
					}],
					onSubmit: function() {
						console.log(this);
					}
				},
				headerFn: function() {}
			}],
			data: []
		};
        const tableActions = new TableLiteFactory(ReportingServiceBySpendTable,
            {
                serviceCallback: Shipments.getAccountBySpend,
                callbackFormat: ['success','error','filter'],
                postRequestCallback: data => {
                    buildTableData(data);
                },
                postRequestErrorCallback: err => {
                    buildTableData(null);
                    toastr.error(err);
                },
                defaultFilters : {
                    size: 20,
                    page: 0,
                    sort: 'id,desc'
                }
            }
        );
        const sort = tableActions.sort;
        const evaluateFilter = tableActions.evaluateFilter;
        const sendRequest = tableActions.sendRequest;

		function buildTableData(data, pagination, filters) {
			/*** START - Building of Data ***/
            tableActions.initializeTableData(data);
			angular.forEach(data.content, function(val) {
				if (!val.startDate && !val.endDate) {
					val.dateRange = "N/A";
				}

				if (val.startDate) {
					val.dateRange = val.startDate;
				}

				if (val.endDate) {
					val.dateRange = val.dateRange + "-" + val.endDate;
				}

				val.serviceId = val.serviceId ? val.serviceId : 'N/A';
				val.titleLogo = {
					type: 'logotype',
					imgSrc: CommonService.isContainLogo(val)
				};
				val.serviceName = val.serviceDetails ? val.serviceDetails.serviceName : 'N/A';
				val.comparableMonthLastYear = CommonService.getFormattedAmount(val.comparableMonthLastYear);
				val.amountMonth = CommonService.getFormattedAmount(val.amountMonth);
				val.amountYear = CommonService.getFormattedAmount(val.amountYear);
				val.comparableYear = CommonService.getFormattedAmount(val.comparableYear);
				val.href = '/margins/view/' + val.id;

                ReportingServiceBySpendTable.data.push(val);
			})
			/*** END - Building of Data ***/

		};
		return ReportingServiceBySpendTable;
	};
})();



// WEBPACK FOOTER //
// ./js/services/tables/ReportingServiceBySpendTableService.js